<template>
  <div id="app" :class="lang">
    <template>
      <router-view />
    </template>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { Locale } from 'vant';
// 引入英文语言包
import enUS from 'vant/es/locale/lang/en-US';
import zhCN from 'vant/es/locale/lang/zh-CN';
import { uuid } from "@/utils/util";
export default {
  data() {
    return {
      isandroid: false,
      appdowshow: false,
      ANDROID_FORCE_APP: 0,
      lang: ""
    };
  },
  name: "App",
  computed: {
    ...mapGetters([
      "themeColor",
      "pageTemplate",
      "isInternational",
      "jumpSwitch",
      "user",
      "pageTemplate"
    ])
  },
  created() {
    this.init();
  },
  mounted() { },
  methods: {
    ...mapActions(["changTemplate", "setLoginUser"]),
    normalizeDeviceId(raw) {
      const s = raw == null ? "" : String(raw).trim();
      if (!s || s === "null" || s === "undefined") return "";
      return s;
    },
    getDeviceIdFromUrl() {
      try {
        const hash = String(window.location.hash || "");
        const idx = hash.indexOf("?");
        if (idx === -1) return "";
        const qs = hash.slice(idx + 1);
        const params = new URLSearchParams(qs);
        const deviceId = params.get("deviceId") || params.get("deviceid");
        return this.normalizeDeviceId(deviceId);
      } catch (e) {
        return "";
      }
    },
    getLangFromUrl() {
      try {
        const hash = String(window.location.hash || "");
        const idx = hash.indexOf("?");
        if (idx === -1) return "";
        const qs = hash.slice(idx + 1);
        const lang = new URLSearchParams(qs).get("lang");
        return (lang || "").trim();
      } catch (e) {
        return "";
      }
    },
    applyLanguage(Language) {
      const lang = Language || "zh_CN";
      this.$i18n.locale = lang;
      localStorage.setItem("Lang", lang);
      this.lang = lang;

      const languageObj =
        lang === "en_US"
          ? { name: "English", code: "en_US" }
          : { name: "中文", code: "zh_CN" };
      localStorage.setItem("language", JSON.stringify(languageObj));

      if (lang === "en_US") Locale.use("en-US", enUS);
      if (lang === "zh_CN") Locale.use("zh-CN", zhCN);
    },
    init() {
      const _this = this;
      const urlLang = this.getLangFromUrl();
      const savedLang = localStorage.getItem("Lang") || "";
      this.applyLanguage(urlLang || savedLang || "zh_CN");

      // URL 优先：首次打开时先用 URL 中的 deviceId 初始化
      const urlDeviceId = this.getDeviceIdFromUrl();
      if (urlDeviceId) {
        sessionStorage.setItem("deviceid", urlDeviceId);
      }

      window.addEventListener("message", function (event) {
        // 处理数据
        let val = event.data;
        if (val && val.type === "lottery") {
          let user = JSON.parse(val.data || "null");
          console.log("----彩票项目222222222222", user);
          sessionStorage.setItem("Authorization", user.token);
          const incomingDeviceId = _this.normalizeDeviceId(user && user.deviceId);
          const fallbackDeviceId =
            _this.normalizeDeviceId(sessionStorage.getItem("deviceid")) || uuid();
          sessionStorage.setItem(
            "deviceid",
            incomingDeviceId || fallbackDeviceId
          );
          sessionStorage.setItem("refreshToken", user.refreshToken);
          sessionStorage.setItem("sessionkey", user.sessionkey);
          sessionStorage.setItem("isSign", user.signconfig.isSign);
          _this.setLoginUser(user);
        }
        if (val && val.type === "Language") {
          let Language = val.data || "zh_CN";
          console.log("------项目语言555", Language);
          _this.applyLanguage(Language);
        }
      });
      setInterval(() => {
        let a = {
          accessToken: sessionStorage.getItem("Authorization"),
          refreshToken: sessionStorage.getItem("refreshToken"),
          deviceid: sessionStorage.getItem("deviceid")
        };
        window.parent.postMessage(a, "*");
      }, 1000);
    }
  }
};
</script>

<style lang="less">
#app {
  background: #fff;
}

.mintui-success {
  font-size: 25px;
}
</style>
